import { useEffect } from 'react';

import { isEqual } from 'lodash-es';

import { useCheckoutState } from '../checkout-provider';

import { useCheckoutTotals } from './use-checkout-totals';

export const useCheckoutInit = () => {
  const [, setCheckoutState] = useCheckoutState();
  const totals = useCheckoutTotals();

  useEffect(() => {
    setCheckoutState(prev => {
      if (isEqual(prev.totals, totals)) {
        return prev;
      }
      if (!prev.totals || !isEqual(prev.totals, totals)) {
        return { ...prev, totals };
      }
      return prev;
    });
  }, [totals, setCheckoutState]);
};
